import { render, staticRenderFns } from "./MariaDb.vue?vue&type=template&id=4f431a92&"
import script from "./MariaDb.vue?vue&type=script&lang=js&"
export * from "./MariaDb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f431a92')) {
      api.createRecord('4f431a92', component.options)
    } else {
      api.reload('4f431a92', component.options)
    }
    module.hot.accept("./MariaDb.vue?vue&type=template&id=4f431a92&", function () {
      api.rerender('4f431a92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/products/MariaDb.vue"
export default component.exports